module.exports = __webpack_public_path__ + "img/AddAlertOutlined.537dbaf6.svg";